// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.outer[data-v-5ef425c8]{margin-top:15px}.info-pad[data-v-5ef425c8]{margin-top:6px}`, "",{"version":3,"sources":["webpack://./components/modal/AlbumCreateModal.vue"],"names":[],"mappings":"AACA,wBACE,eAAA,CAGF,2BACE,cAAA","sourcesContent":["\n.outer {\n  margin-top: 15px;\n}\n\n.info-pad {\n  margin-top: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
